export default {
  login: '/api/user/login',
  getuser: '/api/user/getuser',
  getnewmessagecount: '/api/usermall/getnewmessagecount',
  getmaindata: '/api/mall/getmaindata'
}
